import { useAtomValue } from 'jotai';

import { ProviderResourcesCollapsibleContainerConnected } from '@grow-therapy-team/seedling-components';

import {
  inSessionPatientInformationAtom,
  providerShortIdAtom,
  selectedClientInfoAtom,
  selectedClientUserShortIdAtom,
} from '../state';
import { useCachedPatientByShortId } from '../useGetPatientByShortId';

export function ProviderResourcesCollapsibleContainerWrapper() {
  const clientUserShortId = useAtomValue(selectedClientUserShortIdAtom) ?? '';
  const providerShortId = useAtomValue(providerShortIdAtom) ?? '';
  const appointmentShortId = useAtomValue(inSessionPatientInformationAtom)?.inSessionAppointmentShortId ?? undefined;
  const selectedPatientShortId = useAtomValue(selectedClientInfoAtom)?.patientShortId;
  const { data: cachedPatientData } = useCachedPatientByShortId(selectedPatientShortId);
  const isClientUserMinor = cachedPatientData?.patientChart?.clientUser?.isMinor ?? false;
  const isPatientEnrolledInStructuredCareProgram =
    cachedPatientData?.patientChart?.isEnrolledInStructuredCareProgram ?? false;

  return (
    <ProviderResourcesCollapsibleContainerConnected
      clientUserShortId={clientUserShortId}
      providerShortId={providerShortId}
      isHidden={isClientUserMinor}
      isPatientEnrolledInStructuredCareProgram={isPatientEnrolledInStructuredCareProgram}
      appointmentShortId={appointmentShortId}
      isInverse
    />
  );
}
